let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("lnnYm"), load("5odbj"), load("2mt3f"), load("lPQcc"), load("6lM2n")]).then(() => parcelRequire('esDVy'));